import { Injectable } from "@angular/core";
import TiposDocumento from "@shared/enums/tipos-documento.enum";
import { ApiService } from "./api.service";
import { IResponseAPIListado } from "@models/responseAPI.interface";
import { assignToModel } from "@shared/utils/fieldsMap.utils";
import { Archivo } from "@models/archivo.model";
import { Usuario } from "@models/usuario.model";
import { TipoDocumento } from "@models/tipo-documento.model";
import { environment } from "@env/environment";

@Injectable({
	providedIn: "root",
})
export class DocumentoService {
  private env = environment.env;

	constructor(private apiService: ApiService) { }

	async obtenerDocumentos(
		isLicencia: 1 | 2,
		id: number,
		tipoDocumento?: number
	): Promise<{ data: Archivo[]; msg: string; success: boolean }> {
		const body: any = { isLicencia, id };
		if (tipoDocumento) body.tipoDocumento = tipoDocumento;
		const { data, msg, success } =
			await this.apiService.privatePost<IResponseAPIListado>(
				`listar-documentos-licencia`,
				body
			);
		const archivos = data.map((l: any) => {
			l.tipo = assignToModel(TipoDocumento, l, {
				codigo: l.tde_codigo !== undefined ? "tde_codigo" : "tdo_codigo",
				nombre: l.tde_nombre !== undefined ? "tde_nombre" : "tdo_nombre",
				requerido: "syn_codigo_obligatorio",
				nombre_archivo: "tdo_nombre_archivo",
				ruta: "tdo_url"
			});
			l.tipo.obligatorio = {
				codigo: l.syn_codigo_obligatorio,
				nombre: l.obligatorio,
			}
			l.estado = {
				codigo: l.edo_codigo,
				nombre: l.edo_nombre,
			};
			l.usuario_creador = assignToModel(Usuario, l, {
				rut_usuario: "usu_rut_creador",
			});
			l.usuario_creador = assignToModel(Usuario, l, {
				rut_usuario: "usu_rut_actualizador",
			});
			l.s3 = {
				bucket: l.archivo.s3_bucket,
				key: l.archivo.s3_key,
				type: l.archivo.content_type,
				length: l.archivo.content_length,
				etag: l.archivo.etag,
				ultima_modificacion: l.archivo.last_modified,
				metadada: l.archivo.metadata,
				base64: l.archivo.base64,
			};
			return assignToModel(Archivo, l, {
				id: "lid_id",
				nombre: "lid_archivo",
				ruta: "lid_ruta",
				uuid: "lid_uuid",
				fecha_ingreso: "lid_fecha_ingreso",
				fecha_actualizacion: "lid_fecha_actualizacion",
			});
		});
		return { data: archivos, msg, success };
	}


	async obtenerDocumentoMRE(
		documentId: number
	): Promise<{ data: any[]; msg: string; success: boolean }> {
		const body: any = { documentId };

		const { data, msg, success } =
			await this.apiService.privatePost<IResponseAPIListado>(
				`rec-documentos-licencia-mre`,
				body
			);

		const mre = data.map((l: any) => {
			return {
				mre_codigo: l.mre_codigo,
				mre_nombre: l.mre_nombre,
				ldm_id: l.ldm_id,
			}
		});
		return { data: mre, msg, success };
	}
}
